module.exports = __webpack_public_path__ + "img/news-2.b138c123.jpg";